/* FS mapping — moved out of pages/FsMapping.jsx in split step 6e (28-Oct-2026), unchanged. */

/* --- Import parsing helpers --- */
async function parseMappingFile(file) {
  const name = file.name.toLowerCase();
  const buf = await file.arrayBuffer();
  const rows = name.endsWith(".csv") ? parseCsvRows(new TextDecoder().decode(buf))
                                       : await parseXlsxRows(buf);
  // Normalize headers (case/whitespace tolerant), map to canonical keys.
  if (!rows.length) throw new Error("File is empty");
  const headerMap = {
    "account code": "account_code",
    "account name": "account_name",
    "fs mapping":   "fs_mapping",
    "note mapping": "note_mapping",
  };
  const header = rows[0].map((h) => (h || "").toString().trim().toLowerCase());
  const idx = {};
  for (const [k, v] of Object.entries(headerMap)) idx[v] = header.indexOf(k);
  if (idx.account_code < 0) throw new Error("Missing required column: Account Code");
  const out = [];
  for (let i = 1; i < rows.length; i++) {
    const r = rows[i]; if (!r || r.every((c) => !c && c !== 0)) continue;
    const rec = {
      account_code: (r[idx.account_code] ?? "").toString().trim(),
      fs_mapping:   idx.fs_mapping >= 0 ? (r[idx.fs_mapping] ?? "").toString().trim() : "",
      note_mapping: idx.note_mapping >= 0 ? (r[idx.note_mapping] ?? "").toString().trim() : "",
    };
    if (rec.account_code) out.push(rec);
  }
  if (!out.length) throw new Error("No data rows found under the header");
  return out;
}

function parseCsvRows(text) {
  // Minimal CSV — handles quoted values with commas + escaped quotes.
  const rows = []; let cur = []; let field = ""; let inQ = false;
  for (let i = 0; i < text.length; i++) {
    const c = text[i];
    if (inQ) {
      if (c === '"' && text[i + 1] === '"') { field += '"'; i++; }
      else if (c === '"') { inQ = false; }
      else { field += c; }
    } else {
      if (c === '"') inQ = true;
      else if (c === ",") { cur.push(field); field = ""; }
      else if (c === "\n") { cur.push(field); rows.push(cur); cur = []; field = ""; }
      else if (c === "\r") { /* skip */ }
      else { field += c; }
    }
  }
  if (field.length || cur.length) { cur.push(field); rows.push(cur); }
  return rows.filter((r) => r.some((v) => v !== ""));
}

async function parseXlsxRows(buf) {
  // Lazy-load xlsx to keep bundle lean.
  const XLSX = await import("xlsx");
  const wb = XLSX.read(buf, { type: "array" });
  const ws = wb.Sheets[wb.SheetNames[0]];
  return XLSX.utils.sheet_to_json(ws, { header: 1, defval: "" });
}

export { parseMappingFile, parseCsvRows, parseXlsxRows };
